export class StorageUsage {
	public used: number = 0;
	public usedText: string = '';
	public total: number = 0;
	public totalText: string = '';
	public free: number = 0;
	public freeText: string = '';
}
